import { Link } from 'react-router-dom'

function Home() {
  return (
    <main>
      <h1>HOME</h1>
      <div >
        <img height="300" width="500" src="./images/chia-fruit-drink.jpg" alt="Chia Fruit Shake" />
        <div>
          Photo by <a href="AUTHOR_LINK">Brenda Godinez</a> on <a href="UNSPLASH_LINK">Unsplash</a>
        </div>
      </div>
      <Link to="/places">
        <button className="btn-primary">Places Page</button>
      </Link>
    </main>
  );
}

export default Home;
